import http from 'api/http';
import { boatAPI, systemAPI } from 'api/requests';

import {
  BOAT_SELECT_TYPE,
  BOAT_SELECT_ENGINE_TYPE,
  BOAT_SET_DETAILS_SUCCESS,
  BOAT_SET_DETAILS_ERROR, BOAT_CLEAR_DETAILS, BOAT_UPDATE_DETAILS
} from '../actionTypes';

export function selectBoatType(boatType) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: BOAT_SELECT_TYPE,
        payload: boatType
      });
      resolve();
    });
  };
}

export function selectEngineType(engineType) {
  return {
    type: BOAT_SELECT_ENGINE_TYPE,
    payload: engineType
  };
}

export function updateBoatDetails(payload) {
  return {
    type: BOAT_UPDATE_DETAILS,
    payload
  };
}

export function setBoatDetails(id) {
  return dispatch => {
    let payload = {};

    return  http.get(boatAPI.details(id))
      .then(({data}) => {
        payload = data;
        return Promise.all([
          http.get(systemAPI.getSystemsForBoat(id)),
          http.get(boatAPI.getEnteredCubicCapacity(id)),
          http.get(boatAPI.getFloatationTestReports(id)),
          http.get(boatAPI.getAdditionalDocs(id)),
        ]);
      })
      .then((result) => {
        payload.boatSystems = result[0].data;
        payload.cubicCapacity = result[1].data;
        payload.floatationCapacity = result[2].data;
        payload.additionalFiles = result[3].data;

        return dispatch({
          type: BOAT_SET_DETAILS_SUCCESS,
          payload
        });
      })
      .catch(error => {
        dispatch({
          type: BOAT_SET_DETAILS_ERROR
        });
      });
  };
}

export function clearBoatDetails() {
  return {
    type: BOAT_CLEAR_DETAILS
  };
}



// WEBPACK FOOTER //
// ./src/app/store/actions/boat.js